export default function downloadFile(blob, fileName) {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    // in case the blob uses a lot of memory
    setTimeout(() => URL.revokeObjectURL(link.href), 7000);
};
